module.exports = __webpack_public_path__ + "static/media/banner-natal-2023.e6affc48.png";